import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type {
    ApiStockGatheringCreateLeavesPayload,
    ApiStockGatheringCreateLeavesResult,
    ApiStockGatheringContentData,
    ApiStockGatheringData,
    ApiStockReserveData,
    StockGatheringContentFilter,
    StockGatheringFilter,
    StockReserveFilter,
} from "./types";

interface StockGatheringsResponse {
    gatherings: ApiStockGatheringData[];
}

interface StockGatheringContentsResponse {
    gatheringContents: ApiStockGatheringContentData[];
}

type StockGatheringCreateLeavesResponse = ApiStockGatheringCreateLeavesResult;

interface StockReservesResponse {
    reserves: ApiStockReserveData[];
}

/** Транспортный слой OMP — комплектовочные ведомости и резервы. */
export const stockGatheringsApi = {
    /**
     * Загружает КВ по фильтру.
     * @param params фильтр КВ
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            flt?: StockGatheringFilter;
        },
        config?: RequestConfig,
    ): Promise<ApiStockGatheringData[]> => {
        const data = await ompApiClient.postOmega<StockGatheringsResponse>("stock/gatherings.loadByFilter", params, config);

        return data.gatherings;
    },

    /** Состав КВ. */
    content: {
        /**
         * Загружает строки состава КВ.
         * @param params фильтр состава
         * @param config опции HTTP-запроса
         */
        load: async (
            params: {
                flt?: StockGatheringContentFilter;
            },
            config?: RequestConfig,
        ): Promise<ApiStockGatheringContentData[]> => {
            const data = await ompApiClient.postOmega<StockGatheringContentsResponse>(
                "stock/gatherings/contents.loadByFilter",
                params,
                config,
            );

            return data.gatheringContents;
        },

        /**
         * Создает отпуски по резервам строки состава КВ.
         * @param payload резервы, код строки состава и параметры формирования отпуска
         * @param config опции HTTP-запроса
         */
        createLeaves: async (
            payload: ApiStockGatheringCreateLeavesPayload,
            config?: RequestConfig,
        ): Promise<ApiStockGatheringCreateLeavesResult> => {
            return ompApiClient.postOmega<StockGatheringCreateLeavesResponse>(
                "stock/gatherings/contents.createLeaves",
                payload,
                config,
            );
        },
    },

    /** Резервы строк состава КВ. */
    reserves: {
        /**
         * Загружает резервы по фильтру.
         * @param params фильтр резервов
         * @param config опции HTTP-запроса
         */
        load: async (
            params: {
                flt?: StockReserveFilter;
            },
            config?: RequestConfig,
        ): Promise<ApiStockReserveData[]> => {
            const data = await ompApiClient.postOmega<StockReservesResponse>("stock/reserves.loadByFilter", params, config);

            return data.reserves;
        },
    },
} as const;
